import { Box, Button, GridDirection, GridSize } from "@mui/material";

export interface CustomToggleOption {
  value: string | boolean | number;
  label: string;
}

interface CustomToggleProps {
  options: Array<CustomToggleOption>;
  value: string | boolean | number | null | undefined;
  setValue: Function;
  direction?: GridDirection;
  fullWidth?: boolean;
  padding?: string;
  justifyContent?: string;
  itemSize?: GridSize;
  error?: boolean;
}

const CustomToggle = ({
  options,
  value,
  setValue,
  direction,
  fullWidth,
  padding,
  justifyContent,
  itemSize,
  error,
}: CustomToggleProps) => {
  const handleChange = (newValue: string | boolean | number) => {
    if (value === newValue) {
      if (typeof newValue !== "boolean") {
        setValue(undefined);
      }
    } else {
      setValue(newValue);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: direction ? direction : "row",
        justifyContent: justifyContent ? justifyContent : "start",
        alignItems: "center",
      }}
    >
      {options.map((op, index) => (
        <Box key={`customToggle_${index}`} sx={{ margin: "4px" }}>
          <Button
            onClick={() => handleChange(op.value)}
            variant={op.value === value ? "darkBlue" : "notSelected"}
            fullWidth={fullWidth}
            sx={{
              textAlign: fullWidth ? "center" : "start",
              paddingTop: padding ? padding : "6px",
              paddingBottom: padding ? padding : "6px",
              border:
                error === true ? "solid 1px red !important" : "auto !important",
              // marginRight: index === 0 ? "1rem" : "0px",
              marginRight: "5px",
              width: `${itemSize}px`,
            }}
          >
            {op.label}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default CustomToggle;
